<template>
  <div class="d-flex flex-column" data-cy="filter-container">
    <small
      class="font-weight-bold text-muted input-label"
      data-cy="filter-label"
    >
      Buscar
    </small>

    <!-- Actual search box -->
    <div class="form-group mb-0 has-search" data-cy="filter-form-group">
      <input
        ref="input-search"
        type="text"
        class="input-search form-control form-control-lg rounded-0"
        id="search"
        :placeholder="placeholder"
        v-model="search"
        autocomplete="new-password"
        data-cy="campo-buscar"
      />
    </div>
    <hr class="w-100 mb-0" data-cy="filter-separator" />
  </div>
</template>

<script>
export default {
  name: "search-filter",
  props: {
    placeholder: {
      type: String,
      default: "Buscar..."
    }
  },
  computed: {
    search: {
      get() {
        return this.$store.getters.search;
      },
      set(value) {
        this.$store.dispatch("set_search", value);
        this.$emit("input", value);
      }
    }
  }
};
</script>

<style>
.input-search {
  height: 4rem;
  width: 100%;
}
</style>
